if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const courseBox = this.dataset.bcwCourseManaged === 'true'
          ? document.getElementById(`upsell-box-${this.dataset.sectionId}`)
          : null;
        const courseVariantId = courseBox?.querySelector('input[type="checkbox"]')?.checked
          ? Number(courseBox.dataset.variantId)
          : 0;

        // Serialize the confirmed product + optional course with gift maintenance.
        // A timer cannot establish that Shopify has created the main cart yet.
        const request = (window.bcwCartWriteQueue || Promise.resolve())
          .catch(() => {})
          .then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status || !courseVariantId) return response;
            return this.addCourseAfterProduct(response, courseVariantId, formData.get('id'));
          });
        window.bcwCartWriteQueue = request.catch(() => {});

        request
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async addCourseAfterProduct(productResponse, courseVariantId, productVariantId) {
        try {
          const cartResponse = await fetch(`${window.routes.cart_url}.js`, { cache: 'no-store' });
          if (!cartResponse.ok) return productResponse;
          const cart = await cartResponse.json();
          const productIsPresent = cart.items.some((item) =>
            String(item.variant_id) === String(productVariantId) && item.original_line_price > 0
          );
          if (!productIsPresent || cart.items.some((item) => Number(item.variant_id) === courseVariantId)) {
            return productResponse;
          }

          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: courseVariantId,
              quantity: 1,
              sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
              sections_url: window.location.pathname,
            }),
          });
          const courseResponse = await response.json();
          if (!response.ok || courseResponse.status) {
            console.warn('BCW free course was not added; the selected product remains in the cart.');
            return productResponse;
          }
          // Keep the main product identity for cart events; only refresh the HTML.
          return { ...productResponse, sections: courseResponse.sections || productResponse.sections };
        } catch (error) {
          console.warn('BCW free course could not be confirmed; the selected product is not retried.', error);
          return productResponse;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
